import React, { useEffect, createElement, Component } from 'react';
import { Toaster } from 'sonner';
import { StickyBar } from './components/StickyBar';
import { HeroSection } from './components/HeroSection';
import { SocialProof } from './components/SocialProof';
import { ProblemSection } from './components/ProblemSection';
import { EmotionalTransition } from './components/EmotionalTransition';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { PackComposite } from './components/PackComposite';
import { BonusSection } from './components/BonusSection';
import { UrgencySection } from './components/UrgencySection';
import { OfferSection } from './components/OfferSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TrustBar } from './components/TrustBar';
import { FAQSection } from './components/FAQSection';
import { PurchasePopup } from './components/PurchasePopup';
import { Footer } from './components/Footer';
import { META_PIXEL_ID, PAYMENT_LINK } from './utils/constants';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    try {
      const script = document.createElement('script');
      script.async = true;
      script.innerHTML = `
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '${META_PIXEL_ID}');
        fbq('track', 'PageView');
      `;
      document.head.appendChild(script);
    } catch (error) {
      console.error('Meta Pixel initialization error:', error);
    }
    // UTMify tracking script
    try {
      const utmifyScript = document.createElement('script');
      utmifyScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
      utmifyScript.async = true;
      utmifyScript.defer = true;
      utmifyScript.setAttribute('data-utmify-prevent-subids', '');
      document.head.appendChild(utmifyScript);
    } catch (error) {
      console.error('UTMify initialization error:', error);
    }
    // UTMify Pixel
    try {
      ;
      (window as any).pixelId = '69f92c43591a1c047f77b16d';
      const pixelScript = document.createElement('script');
      pixelScript.setAttribute('async', '');
      pixelScript.setAttribute('defer', '');
      pixelScript.setAttribute('src', 'https://cdn.utmify.com.br/scripts/pixel/pixel.js');
      document.head.appendChild(pixelScript);
    } catch (error) {
      console.error('UTMify Pixel initialization error:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-white" data-id="element-0">
      <StickyBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SocialProof data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <EmotionalTransition data-id="element-5" />
      <ProductPresentation data-id="element-6" />
      <WhatIsIncluded data-id="element-7" />
      <PackComposite data-id="element-8" />
      <BonusSection data-id="element-9" />
      <UrgencySection data-id="element-10" />
      <OfferSection data-id="element-11" />
      <TestimonialsSection data-id="element-12" />
      <GuaranteeSection data-id="element-13" />
      <TrustBar data-id="element-14" />
      <FAQSection data-id="element-15" />

      {/* Final CTA */}
      <section className="bg-blue-900 py-16 px-4 text-center text-white" data-id="element-16">
        <div className="max-w-4xl mx-auto" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-18">
            Inizia oggi a trasformare le tue lezioni di yoga per bambini
          </h2>
          <div className="mb-8" data-id="element-19">
            <CountdownTimer variant="light" data-id="element-20" />
          </div>
          <button onClick={() => window.open(PAYMENT_LINK, '_blank')} className="bg-green-600 hover:bg-green-700 text-white font-bold text-xl py-5 px-10 rounded-full shadow-lg shadow-green-600/50 transition-all duration-300 animate-pulse" data-id="element-21">
            ACQUISTA ORA
          </button>
        </div>
      </section>

      <Footer data-id="element-22" />
      <PurchasePopup data-id="element-23" />
      <Toaster data-id="element-24" />
    </div>;
}
function CountdownTimer({
  variant
}: {
  variant?: 'default' | 'light';
}) {
  const Component = require('./components/CountdownTimer').CountdownTimer;
  return <Component variant={variant} data-id="element-25" />;
}